import { SearchOrderDocumentParams, SearchOrderDocumentResult } from '@my-account/const';
import { StateUtils } from '@spartacus/core';
import { SEARCH_ORDER_DOCUMENT_ENTITY } from '../my-account-state';

export const SEARCH_ORDER_DOCUMENT = '[My Account] Search Order Document';
export const SEARCH_ORDER_DOCUMENT_SUCCESS = '[My Account] Search Order Document Success';
export const SEARCH_ORDER_DOCUMENT_FAIL = '[My Account] Search Order Document Fail';
export const SEARCH_ORDER_DOCUMENT_RESET = '[My Account] Search Order Document Reset';

export class SearchOrderDocument extends StateUtils.LoaderLoadAction {
  readonly type = SEARCH_ORDER_DOCUMENT;

  constructor(public payload: SearchOrderDocumentParams) {
    super(SEARCH_ORDER_DOCUMENT_ENTITY);
  }
}

export class SearchOrderDocumentSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = SEARCH_ORDER_DOCUMENT_SUCCESS;

  constructor(public payload: SearchOrderDocumentResult) {
    super(SEARCH_ORDER_DOCUMENT_ENTITY);
  }
}

export class SearchOrderDocumentFail extends StateUtils.LoaderFailAction {
  readonly type = SEARCH_ORDER_DOCUMENT_FAIL;

  constructor() {
    super(SEARCH_ORDER_DOCUMENT_ENTITY);
  }
}

export class SearchOrderDocumentReset extends StateUtils.LoaderResetAction {
  readonly type = SEARCH_ORDER_DOCUMENT_RESET;

  constructor() {
    super(SEARCH_ORDER_DOCUMENT_ENTITY);
  }
}

export type SearchOrderDocumentActions =
  | SearchOrderDocument
  | SearchOrderDocumentSuccess
  | SearchOrderDocumentFail
  | SearchOrderDocumentReset;
